export default __webpack_public_path__ + "static/media/Bg.d501df91.png";